import * as actions from '../actionTypes/ShipAndPayActionTypes';

export const changeAddressTypeAction = (addressType) => ({
    type: actions.CHANGE_ADDRESS_TYPE,
    addressType,
});

export const submitShippingAddressForm = (
    formValues,
    isMilitaryAddress,
    shippingGroupid,
    continueToReview,
    getServiceLevels,
    isSilverItem,
    isUserLoggedIn,
    removeRestrictedItems
) => {
    const shippingAddress = {
        address: {
            secondaryPhone: formValues.secondaryPhone
                ? formValues.secondaryPhone.replace(/\D+/g, '')
                : undefined,
            lineOne: formValues.lineOne,
            lineTwo: formValues.lineTwo,
            city: isMilitaryAddress ? formValues.militaryAddressType : formValues.city,
            state: formValues.state ? formValues.state : '',
            country: isMilitaryAddress ? 'AP' : 'US',
            phone: formValues.phone && formValues.phone.replace(/\D+/g, ''),
            zip: formValues.zip,
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            company: formValues.company,
            militaryAddressType: formValues.militaryAddressType,
        },
        instructions: [{ message: formValues.instructions }],
        id: shippingGroupid,
        getServiceLevels,
        continueToReview,
        isSilverItem,
        isUserLoggedIn,
    };
    if (!isMilitaryAddress) {
        delete shippingAddress.address.militaryAddressType;
    }
    if (removeRestrictedItems) {
        shippingAddress.removeRestrictedItems = removeRestrictedItems;
    }
    shippingAddress.type = 'HOME';
    if (formValues.shippingAddressType === 'Store') {
        shippingAddress.type = 'STORE';
        shippingAddress.store = {
            id: formValues.selectedStoreId,
        };
    }

    if (formValues.isGiftRegistryAddr) {
        shippingAddress.address.relationships = {
            giftRegistry: {
                id: formValues.id,
            },
        };
    } else if (isUserLoggedIn && formValues.id !== undefined) {
        shippingAddress.address.relationships = {
            accountAddress: {
                id: formValues.id,
            },
        };
    }
    return {
        type: actions.SUBMIT_SHIPPING_ADDRESS_FORM,
        shippingAddress,
    };
};

export const setServiceLevelsRequested = (value) => ({
    type: actions.SERVICE_LEVELS_REQUESTED,
    getServiceLevels: value,
});

export const addAddressesToAddressList = (addressList) => ({
    type: actions.ADD_ADDRESSES_TO_ADDRESS_LIST,
    addressList,
});

export const setDefaultAddress = (selectedAddress, updateSelectedAddress) => ({
    type: actions.SET_DEFAULT_ADDRESS,
    payload: { selectedAddress, updateSelectedAddress },
});

export const handleInternationalShippError = (error) => ({
    type: actions.HANDLE_INTERNATIONAL_SHIPPING_ERROR,
    handleInternationalShippError: error,
});

export const setOrderShippingMethods = (shippingMethods) => ({
    type: actions.SET_ORDER_SHIPPING_METHODS,
    shippingMethods,
});
